// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Niger */
const NE = /^(?:(?:23|7[0467]|[89]\d)\d{6})$/;

export default NE;
